import React from 'react';
import { ExternalSwitcherLink, ButtonLink } from '@app/router';
import { trackEvent as segmentTrackEvent, EVENTS, SCREENS } from '@app/segment';
import { useGATrackEvent, Events, Categories } from '@app/analytics';
import { FacebookIcon, InstagramIcon, TwitterIcon } from '@app/ui';
import { StyledModalSocialWrapper } from './UserGeneratedContentModal.styles';

const UserGeneratedContentSocialLinks = () => {
  const gaTrack = useGATrackEvent();
  const trackSocialClick = (platform: string) => {
    segmentTrackEvent(EVENTS.SOCIAL_MEDIA_LINK_CLICKED, {
      screenName: SCREENS.AS_SEEN_ON_INSTAGRAM,
      socialPlatform: platform,
    });
    gaTrack(
      Events.SocialMediaLinkClicked,
      Categories.AsSeenOnInstagram,
      platform,
    );
  };

  return (
    <StyledModalSocialWrapper>
      <li key="UserGeneratedContentModalSocialLink_Facebook">
        <ButtonLink
          as={ExternalSwitcherLink}
          to="https://www.facebook.com/stockxdotcom/"
          onClick={() => trackSocialClick('Facebook')}
        >
          <FacebookIcon boxSize={5} />
        </ButtonLink>
      </li>
      <li key="UserGeneratedContentModalSocialLink_Instagram">
        <ButtonLink
          as={ExternalSwitcherLink}
          to="https://www.instagram.com/stockx/"
          onClick={() => trackSocialClick('Instagram')}
        >
          <InstagramIcon boxSize={5} />
        </ButtonLink>
      </li>
      <li key="UserGeneratedContentModalSocialLink_Twitter">
        <ButtonLink
          as={ExternalSwitcherLink}
          to="https://twitter.com/stockx"
          onClick={() => trackSocialClick('Twitter')}
        >
          <TwitterIcon boxSize={5} />
        </ButtonLink>
      </li>
    </StyledModalSocialWrapper>
  );
};

export default UserGeneratedContentSocialLinks;
